/* eslint-disable react/prop-types */
import React from 'react'

import LiveSelect from 'live/components/forms/ui/select'

import { HIGHEST_SEVERITY, SECOND_HIGHEST_SEVERITY } from '../../constants'

import { RegularIcon } from '../styles'
import { SelectOptionWithIconColor, SelectValueWithIcon } from '../styles/editor'

const SeveritySelector = ({ severity, setSeverity, disabled }) => (
    <LiveSelect
        noFormGroup
        searchable={false}
        clearable={false}
        disabled={disabled}
        options={[
            {
                iconClass: 'fas fa-check-circle',
                color: '#52BE80',
                label: 'Normal',
                value: 'normal'
            },
            {
                color: '#F89300',
                iconClass: 'fas fa-exclamation-circle',
                label: 'Warning',
                value: SECOND_HIGHEST_SEVERITY
            },
            {
                color: '#C43535',
                iconClass: 'fas fa-exclamation-circle',
                label: 'Critical',
                value: HIGHEST_SEVERITY
            }
        ]}
        value={severity}
        className="Select-small"
        valueRenderer={option => (
            <SelectValueWithIcon>
                <RegularIcon
                    color={option.color}
                    className={`fas fa-${option.value === 'normal' ? 'check' : 'exclamation'}-circle`}
                />
                <div title={option.label}>{option.label}</div>
            </SelectValueWithIcon>
        )}
        optionComponent={SelectOptionWithIconColor}
        onChange={option => {
            setSeverity(option)
        }}
    />
)

export default SeveritySelector
